import React from 'react';

const Code = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path d="m10.162 7.9414-8.6973 7.6113 8.6973 7.6113 1.0527-1.2051-7.3203-6.4062 7.3203-6.4062-1.0527-1.2051z" />
    <path d="m17.895 2.9238-5.0781 26 1.5703 0.30664 5.0781-26-1.5703-0.30664z" />
    <path d="m22.201 7.9512-1.0723 1.1875 7.3301 6.6191-7.3125 6.1934 1.0352 1.2207 8.709-7.375-8.6895-7.8457z" />
  </svg>
);

export default Code;
